import React from "react";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section className="about" dir="rtl">
      <style>{`
        .about {
          padding: 80px 20px;
          background: linear-gradient(180deg, rgba(249,249,249,0.8), #ffffff);
          font-family: "Noto Sans Arabic", sans-serif;
        }

        .about__container {
          max-width: 1100px;
          margin: 0 auto;
        }

        .about__title-wrapper {
          text-align: center;
          margin-bottom: 50px;
        }

        .about__title {
          position: relative;
          display: inline-block;
          font-size: 32px;
          font-weight: 800;
          color: #143414;
          letter-spacing: 0.5px;
        }

        .about__title::before, 
        .about__title::after {
          content: '';
          position: absolute;
          top: 50%;
          width: 35px;
          height: 2px;
          background-color: #29521e;
        }

        .about__title::before {
          right: 100%;
          margin-right: 15px;
        }

        .about__title::after {
          left: 100%;
          margin-left: 15px;
        }

        .about__content {
          display: grid;
          grid-template-columns: 1fr 420px;
          gap: 40px;
        }

        .about__text p {
          color: #2b2b2b;
          font-size: 17px;
          line-height: 1.9;
          margin-bottom: 18px;
        }

        .about__image {
          text-align: center;
          margin:"auto;
        }

        .about__image img {
          width: 100%;
          max-width: 400px;
          border-radius: 18px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.12);
          transition: transform 0.4s ease;
        }

        .about__image img:hover {
          transform: scale(1.03);
        }

        @media (max-width: 992px) {
          .about__content {
            grid-template-columns: 1fr;
            text-align: center;
          }
          .about__image {
            order: -1;
            margin-bottom: 30px;
            display:flex;
                justify-content: center;

          }
          .about__image img {
            max-width: 80%;
          }
        }

        @media (max-width: 600px) {
          .about {
            padding: 60px 15px;
          }
          .about__title {
            font-size: 26px;
          }
          .about__text p {
            font-size: 15.5px;
            line-height: 1.8;
          }
        }
      `}</style>

      <div className="about__container">
        <motion.div
          className="about__title-wrapper"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="about__title">من نحن</h2>
        </motion.div>

        <div className="about__content">
          <motion.div
            className="about__text"
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <p>
              الأستاذ <strong>محمد إبراهيم أحمد (محمد إبراهيم أبو عدبه)</strong>{" "}
              محامٍ بالنقض والإدارية العليا، وصاحب مكتب محمد إبراهيم أبو عدبة
              للمحاماة بمدينة نصر.
            </p>

            <p>
              حاصل على ليسانس الحقوق من جامعة القاهرة، وماجستير في التجارة
              الدولية، ويتمتع بخبرة قانونية واسعة تمتد عبر مختلف فروع القانون.
            </p>

            <p>
              يتولى المكتب الترافع في جميع أنواع الدعاوى وفقًا لسياسة دقيقة
              تراعي أعلى معايير المهنية والسرية القانونية، مع تقديم استشارات
              متخصصة وحلول قانونية متكاملة.
            </p>

            <p>
              كما يتميز الأستاذ محمد إبراهيم أبو عدبة بكونه باحثًا وخبيرًا في
              قوانين وقضايا التأمينات والمعاشات، مما يمنح عملاء المكتب ميزة
              إضافية من الخبرة والتحليل الدقيق في هذا المجال الحيوي.
            </p>
          </motion.div>

          <motion.div
            className="about__image"
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <img
              src="https://res.cloudinary.com/defcamc5x/image/upload/v1762021822/onn9i95t9xgiyueaawev.jpg"
              alt="محمد إبراهيم أبو عدبة المحامي بالنقض والإدارية العليا"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
